/** * @Author: liujiannan * @Date: 2020-09-14 11:19:54 * @Description 意见反馈
*/
<template>
  <div class="other-feedback">
    <div class="other-feedback-tips">
      <img :src="require('@/assets/feedback_text.png')" />
      <span>请输入反馈的内容，我们会为您更好的服务</span>
    </div>
    <div class="other-feedback-tabs">
      问题类型:
      <span
        :class="questionType === 1 ? 'other-feedback-tabs-selected' : ''"
        @click="questionType = 1"
      >
        系统问题
      </span>
      <span
        :class="questionType === 2 ? 'other-feedback-tabs-selected' : ''"
        @click="questionType = 2"
      >
        其他问题
      </span>
      <span class="other-feedback-tabs-chooies">*必选</span>
    </div>
    <van-field
      v-model="content"
      class="other-feedback-content-input"
      autosize
      rows="5"
      type="textarea"
      maxlength="500"
      placeholder="请描述您的问题或建议"
      show-word-limit
    />
    <div class="other-feedback-contact">
      <h4>您的联系方式</h4>
      <van-field
        v-model="email"
        :left-icon="require('@/assets/feedback_msg.png')"
        label=" "
        label-width=".1rem"
        placeholder="您的邮箱"
      />
      <van-field
        v-model="phone"
        :left-icon="require('@/assets/feedback_phone.png')"
        label=" "
        label-width=".1rem"
        placeholder="您的手机"
      />
      <div class="other-feedback-contact-prompt">
        <img :src="require('@/assets/feedback_warning.png')" />
        <span
          >请留下您的联系方式，以便我们能方便了解问题以及向您反馈问题结果</span
        >
      </div>
    </div>
    <ph-button @click="onSubmit" title="提交" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      email: "",
      phone: "",
      content: "",
      questionType: "" // 1系统问题 2其他问题
    };
  },
  methods: {
    onSubmit() {
      if (!this.questionType) {
        this.$toast("请选择问题类型");
        return;
      }
      if (!this.content) {
        this.$toast("反馈内容不能为空");
        return;
      }

      if (this.email && !this.$regular.email(this.email)) {
        this.$toast("邮箱格式不正确");
        return;
      }

      if (this.questionType === 1 && !this.$regular.phone(this.phone)) {
        this.$toast("请输入正确的手机号");
        return;
      }

      this.$http
        .post(this.$api.FEEDBACK_SAVE, {
          phone: this.phone,
          content: this.content,
          email: this.email,
          functionType: "1",
          type: this.questionType
        })
        .then(() => {
          this.$dialog
            .alert({
              title: "",
              message: "提交成功"
            })
            .then(() => {
              this.$router.go(-1);
            });
        });
    }
  }
};
</script>
>

<style lang="less">
.other-feedback {
  font-size: 0.9rem;

  &-tips {
    display: flex;
    align-items: center;
    margin: 0.63rem;
    font-weight: 500;
    font-size: 0.9rem;

    img {
      width: 0.9rem;
      height: 0.9rem;
    }

    span {
      margin-left: 0.3rem;
    }
  }

  &-tabs {
    margin: 0.63rem;
    &-chooies {
      margin-left: 0.93rem;
      color: red;
      font-size: 0.7rem;
      background-color: #fff !important;
    }
    &-selected {
      padding: 0.3rem;
      color: #fff;
      background-color: #108eee !important;
      border-radius: 0.3rem;
    }
    span {
      margin-left: 0.8rem;
      padding: 0.3rem;
      background-color: #efefef;
      border-radius: 0.3rem;
    }
  }

  &-content-input {
    width: calc(100% - 2rem);
    margin: 1rem;
    border: 1px solid #efefef;
    border-radius: 0.5rem;
  }

  .other-feedback-contact {
    border-top: 0.63rem solid #efefef;

    h4 {
      margin: 0.8rem 1rem;
    }

    img {
      width: 0.9rem;
      height: 0.9rem;
    }

    &-prompt {
      margin: 0.63rem;
      color: gray;
    }
  }
}
</style>
